import Vue from 'vue'

import App from './App.vue'
import router from './router'
import axios from './require'
import Swiper from "swiper";
import "swiper/swiper.min.css"
import { Tab, Tabs, Popup, Button, Sidebar, SidebarItem } from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(ElementUI);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Sidebar);
Vue.use(SidebarItem);
// 公共組件
Vue.component(Swiper)
const TopNav = () =>
    import ("@/components/TopNav");
const Top = () =>
    import ("@/components/Top");
const Footer = () =>
    import ("@/components/Footer");
Vue.component('TopNav', TopNav)
Vue.component('Top', Top)
Vue.component('Footer', Footer)
Vue.prototype.$api = axios

Vue.config.productionTip = false
import "@/assets/css/worldeconomy.css"
import "@/assets/css/channel.css";
import "@/assets/css/mobileStyle.css"


new Vue({
    render: h => h(App),
    router,
}).$mount('#app')